module.exports = new __parcel__URL__("grunge.3e6f3ce1.jpg").toString();